var main = {
    jsToggles: function() {
        var linkToggle = document.querySelectorAll('.js-toggle');

        for(i = 0; i < linkToggle.length; i++) {
        linkToggle[i].addEventListener('click', function(event) {
        
        event.preventDefault();
        
        var container = document.getElementById(this.dataset.container);
        
        if (!container.classList.contains('active')) {
            this.classList.add('is-open');
            container.classList.add('active');
            container.style.height = 'auto';
        
            var height = container.clientHeight + 'px';
        
            container.style.height = '0px';
        
            var parentContainer = container.closest('.sub-parent')
        
        
            setTimeout(function () {
            container.style.height = height;
                if (parentContainer != undefined && parentContainer.clientHeight > 0) {
                setTimeout( function() {
                    parentContainer.style.height = 'auto';
                    var parentHeight = parentContainer.clientHeight + 'px';
            
                    parentContainer.style.height = '0px';
        
                    parentContainer.style.height = parentHeight;
                }, 100)
                }
            }, 0);
            
        } else {
            this.classList.remove('is-open');
            
            container.style.height = '0px';
        
            if (container.classList.contains('no-trans')) {
            container.classList.remove('active');
            } else {
            container.addEventListener('transitionend', function () {
                container.classList.remove('active');
            }, {
                once: true
            });
            }
            
            setTimeout(function () {
            var parentContainer = container.closest('.sub-parent')
            var innerSub = container.closest('.inner-sub')
        
            if (innerSub != null) {
                parentContainer.style.height = innerSub.clientHeight + 'px';
            }
            }, 100);
        }
        
        });
        
        }
    },
    preventDefaultForHashLinks: function() {
        // Get all anchor elements
        var anchorElements = document.querySelectorAll('a[href^="#"]');
    
        // Loop through the anchor elements
        anchorElements.forEach(function(anchor) {
            // Check if the href attribute contains #
            anchor.addEventListener('click', function(event) {
                event.preventDefault();

                // Get the target ID from the href
                var targetId = anchor.getAttribute('href').substring(1); // Remove the #

                // Check if an element with the target ID exists in the DOM
                var targetElement = document.getElementById(targetId);

                if (targetElement) {
                    // Define an offset (adjust this value as needed)
                    var offsetTop = 50; // Change this to your desired offset

                    console.log(offset(targetElement).top)
                    // Scroll to the target element with the specified offset
                    window.scrollTo({
                        top: offset(targetElement).top,
                        behavior: 'smooth' // You can change this to 'auto' for an instant scroll
                    });
                }


                function offset(el) {
                    var rect = el.getBoundingClientRect(),
                    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
                }
            });
        });
    },
    firstSecHeight: function() {
        if ( document.querySelector('body.template-index main > .shopify-section:first-of-type')) {
            document.documentElement.style.setProperty('--first-sec-height', `${document.querySelector('body.template-index main > .shopify-section:first-of-type').offsetHeight}px`);
        }
    },
    slideAdapt: function() {
        // const activeSlide = document.querySelectorAll('.product__media-item')[0]
        // if (activeSlide) {
        //     slideAdapt(activeSlide)
        // }

        document.querySelectorAll('.slide-adaptable').forEach(e=> {

            e.addEventListener('slideChanged', function(evt) {
                slideAdapt(evt.detail)
            })

            contentHeight = e.querySelector('.slider__slide > *').offsetHeight 
            slideList = e.querySelector('.slider')
            
            if (contentHeight && slideList) {
                slideList.style.height = contentHeight + 'px';
            }
        })
        
        function slideAdapt(e) {

            var contentHeight = 0
            var slideList = 0

            if (typeof(e.currentElement) != "undefined") {

                contentHeight = e.currentElement?.querySelector('.slider__slide > *').offsetHeight 
                slideList = e.currentElement.closest('.slider') 
            } else {
                contentHeight = e.querySelector('.slider__slide > *').offsetHeight 
                slideList = e.closest('.slider')
            }

            slideList.style.height = contentHeight + 'px';
        }
    },
    applyGlowEffect: function() {
        document.querySelectorAll(".animate--hover-3d-lift .product-card-wrapper").forEach((element) => {
            const inner = element.querySelector(".card__inner");

            inner.style.transform = `rotateX(0deg) rotateY(0deg) translateY(0) scale(1)`;

            element.addEventListener("mousemove", (evt) => {
                const bounds = element.getBoundingClientRect();
                const centerX = bounds.width / 2;
                const centerY = bounds.height / 2;
                const offsetX = evt.clientX - (bounds.left + centerX);
                const offsetY = evt.clientY - (bounds.top + centerY);
                const rotateX = (offsetY / centerY) * 15;
                const rotateY = (offsetX / centerX) * -15;
    
                inner.style.transform = `rotateX(${rotateX}deg) translateY(-22px) rotateY(${rotateY}deg) scale(1.3)`;
                inner.style.boxShadow = `0 30px 60px rgba(0, 0, 0, 0.6)`;
            });

            element.addEventListener("mouseleave", () => {
                inner.style.transform = `rotateX(0deg) rotateY(0deg) scale(1)`;
                inner.style.boxShadow = `0 15px 40px rgba(0, 0, 0, 0.5)`;
            });
        });
    }
}

main.jsToggles()
main.preventDefaultForHashLinks()
main.firstSecHeight()
main.slideAdapt()
main.applyGlowEffect()

// Add event listener for window resize
window.addEventListener('resize', () => {
    main.firstSecHeight();
});